import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import {
  setCompanyDashboardActivitiesData,
  setCompanyDashboardAlertsPriorityCount,
  setCompanyDashboardData
} from 'src/store/modules/dashboard/companyDashboard'

import {
  COMPANY_DASHBOARD_GET,
  COMPANY_DASHBOARD_GET_ACTIVITIES,
  COMPANY_DASHBOARD_GET_ALERTS
} from 'src/constants'

export const getCompanyDashboardData =
  (config = {}) =>
  async (dispatch) => {
    const { query = {} } = config

    try {
      const items = await httpClient.request({
        method: 'get',
        url: {
          pathname: COMPANY_DASHBOARD_GET,
          query
        }
      })

      dispatch(setCompanyDashboardData(items))
    } catch (err) {
      catchError(err)
    }
  }

export const getCompanyActivities =
  (config = {}) =>
  async (dispatch) => {
    const { query = {} } = config

    try {
      const items = await httpClient.request({
        method: 'get',
        url: {
          pathname: COMPANY_DASHBOARD_GET_ACTIVITIES,
          query
        }
      })

      dispatch(setCompanyDashboardActivitiesData(items))
    } catch (err) {
      catchError(err)
    }
  }

export const fetchAlertsPriorityCount =
  (config = {}) =>
  async (dispatch) => {
    const { query = {} } = config

    try {
      const alertsPriorityCount = await httpClient.request({
        method: 'get',
        url: {
          pathname: COMPANY_DASHBOARD_GET_ALERTS,
          query
        }
      })

      dispatch(setCompanyDashboardAlertsPriorityCount(alertsPriorityCount))
    } catch (err) {
      catchError(err)
    }
  }
